import PropTypes from 'prop-types'
import React, { Component, useContext, useState } from 'react'
import {
  Button,
  Container,
  Dropdown,
  Icon,
  Image,
  Menu,
  Responsive,
  Segment,
  Sidebar,
  Visibility,
} from 'semantic-ui-react'
import UserContext from 'UserContext';
import Gravatar from 'components/layout/Gravatar';

import { navigate, Link } from '@reach/router';


const getWidth = () => {
  const isSSR = typeof window === 'undefined';

  return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth
};

const DesktopLoginButtons = props => (
  <Menu.Item position='right'>
    <Button as={Link} to="/login" inverted={!props.fixed}>
      Log in
    </Button>
    <Button as={Link} to="/register" inverted={!props.fixed} primary={props.fixed} style={{marginLeft: '0.5em'}}>
      Sign Up
    </Button>
  </Menu.Item>
);


const DesktopLoggedIn = props => {
  const userContext = useContext(UserContext);

  const logout = () => {
    userContext.setUser(null);
    navigate('/');
  };

  return (<Menu.Item position='right'>
    <Dropdown trigger={<Gravatar />}>
      <Dropdown.Menu>
        <Dropdown.Item onClick={logout} text="Logout"/>
      </Dropdown.Menu>
    </Dropdown>

  </Menu.Item>);
};

const DesktopContainer = props => {
  const [fixed, setIsFixed] = useState(false);

  const hideFixedMenu = () => setIsFixed(false);
  const showFixedMenu = () => {
    if (props.disabledFixed) {
      return;
    }
    setIsFixed(true);
  };

  const userContext = useContext(UserContext);
  const { children, heading, height, currentPage } = props;

    return (
      <Responsive getWidth={getWidth} minWidth={Responsive.onlyTablet.minWidth}>
        <Visibility
          once={false}
          onBottomPassed={showFixedMenu}
          onBottomPassedReverse={hideFixedMenu}
        >
          <Segment
            inverted
            textAlign='center'
            style={{ minHeight: height || 600, padding: '1em 0em', zIndex: 9999}}
            vertical
          >
            <Menu
              fixed={fixed ? 'top' : null}
              inverted={!fixed}
              pointing={!fixed}
              secondary={!fixed}
              size='large'
            >
              <Image rounded src="/assets/images/logos/sayers-logo-small.jpg" style={{height: 65, width: 65, marginLeft: 20}}/>
              <Container>
                <Menu.Item as={Link} to="/" active={currentPage === "home"}>
                  Home
                </Menu.Item>
                <Menu.Item as={Link} to="/about" active={currentPage === "about"}>About</Menu.Item>
                <Dropdown as='span' item simple text='Analytics'>
                  <Dropdown.Menu style={{marginTop: 0}}>
                    <Dropdown.Item as={Link} to="/map-explorer" active={currentPage === "maps"}>Maps</Dropdown.Item>
                    <Dropdown.Item as={Link} to="/charts" active={currentPage === "charts"}>Charts</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                { !!userContext.user ? <DesktopLoggedIn /> : <DesktopLoginButtons fixed={fixed}/>}
              </Container>
            </Menu>
            { heading }
          </Segment>
        </Visibility>

        {children}
      </Responsive>
    );

}

DesktopContainer.propTypes = {
  children: PropTypes.node,
  heading: PropTypes.node,
};

class MobileContainer extends Component {
  state = {};

  handleSidebarHide = () => this.setState({ sidebarOpened: false })

  handleToggle = () => this.setState({ sidebarOpened: true })

  render() {
    const { children, heading } = this.props
    const { sidebarOpened } = this.state

    return (
      <Responsive
        as={Sidebar.Pushable}
        getWidth={getWidth}
        maxWidth={Responsive.onlyMobile.maxWidth}
      >
        <Sidebar
          as={Menu}
          animation='push'
          inverted
          onHide={this.handleSidebarHide}
          vertical
          visible={sidebarOpened}
        >
          <Menu.Item as='a' active>
            Home
          </Menu.Item>
          <Menu.Item as={Link} to="/about">About</Menu.Item>
          <Menu.Item as={Link} to="/coming-soon">Analysis</Menu.Item>
          <Menu.Item as={Link} to="/map-explorer">Maps</Menu.Item>
          <Menu.Item as={Link} to="/map-explorer">Map Explorer</Menu.Item>
          <Menu.Item as='a'>Log in</Menu.Item>
          <Menu.Item as='a'>Sign Up</Menu.Item>
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarOpened}>
          <Segment
            inverted
            textAlign='center'
            style={{ minHeight: 350, padding: '1em 0em' }}
            vertical
          >
            <Container>
              <Menu inverted pointing secondary size='large'>
                <Menu.Item onClick={this.handleToggle}>
                  <Icon name='sidebar' />
                </Menu.Item>
                <Menu.Item position='right'>
                  <Button as='a' inverted>
                    Log in
                  </Button>
                  <Button as='a' inverted style={{ marginLeft: '0.5em' }}>
                    Sign Up
                  </Button>
                </Menu.Item>
              </Menu>
            </Container>
            {heading}
          </Segment>

          {children}
        </Sidebar.Pusher>
      </Responsive>
    )
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node,
  headingDesktop: PropTypes.node,
  headingMobile: PropTypes.node,
};

const ResponsiveContainer = ({
                               children,
                               DesktopHeading,
                               MobileHeading,
                               height,
                               currentPage,
  disableFixed
}) => (
  <div>
    <DesktopContainer
      heading={DesktopHeading}
      height={height || 600}
      currentPage={currentPage}
      disabledFixed={disableFixed}
    >
      {children}
    </DesktopContainer>
    <MobileContainer heading={MobileHeading}>{children}</MobileContainer>
  </div>
)

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
  DesktopHeading: PropTypes.node,
  MobileHeading: PropTypes.node
};

export default ResponsiveContainer;